import { render, staticRenderFns } from "./Role.vue?vue&type=template&id=0b5f95f2"
import script from "./Role.vue?vue&type=script&lang=js"
export * from "./Role.vue?vue&type=script&lang=js"
import style0 from "./Role.vue?vue&type=style&index=0&id=0b5f95f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports